/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {fetchProxy} from "../APIClient.jsx";

export const BuildsAPI = function () {

    function listForImage(imageId) {
        let parameter = {}
        parameter.imageId = imageId;
        return fetchProxy("builds/listForImage", parameter)
    }


    return {
        listForImage
    }
}()